import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Icon from '../../../components/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import partsImg from '../../../images/noimg.jpg';
import Drawer from '../../../components/Drawer';
import CreateSpearparts from './_components/createSpearparts';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import { downloadExcel, downloadPDF, showDate, getPermissionInfo } from '../../../_common/functions';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import { MASTER_DROPDOWN_PAGE_SIZE, PAGE_SIZE } from '../../../_common/constant';
import { titleCell } from '../../../components/elements/function';
import { URLS } from '../../../_config';
import { filterConfigType } from '../../../_config/types';
import Filters from '../../../components/filters';
import Loader from '../../../components/loader';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import { useUserSelector } from '../../../store/selectors/userSelector';


const SpearParts: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const [isOpen, setIsOpen] = useState(false);
    const spearPartsAPI = useSpearPartsApi();
    const { confirm } = useDialog();

    const assetAPI: any = useAssetsApi();

    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [rowData, setRowData] = useState<any>(null)


    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');

    const [partsStatusList, setPartsStatusList] = React.useState<any[]>([]);
    const [partsCategoryList, setPartsCategoryList] = React.useState<any[]>([]);
    const [vendorList, setVendorList] = React.useState<any[]>([]);



    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('spearPartsFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('spearPartsFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const filterConfig: filterConfigType[] = [
        { name: 'Name', type: 'text', key: 'partsName' },
        { name: 'Parts Category', type: 'dropdown', key: 'partsCategoryID', options: partsCategoryList ? partsCategoryList : [] },
        { name: 'Vendor', type: 'dropdown', key: 'vendorID', options: vendorList ? vendorList : [] },
        { name: 'Status', type: 'dropdown', key: 'statusID', options: partsStatusList ? partsStatusList : [] },
    ]

    const addNewRef: any = React.createRef<HTMLButtonElement>();

    const getPartsStatus = () => {

        spearPartsAPI.getPartsStatus({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            let statusList = (resp?.sparePartsStatusList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.partsStatusID
                }
            }));
            setPartsStatusList(statusList);
        }, (error: any) => {
            setPartsStatusList([]);
        });
    }
    const getPartsCategoryList = () => {

        spearPartsAPI.getSparePartsCategoryList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const catList = (resp?.sparePartsCategoryList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.partsCategoryID
                }
            }));
            console.log('catList=================', catList)
            setPartsCategoryList(catList);

        }, (error: any) => {
            setPartsCategoryList([]);

        });
    }
    const getvenderList = () => {

        assetAPI.GetvenderList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const vendorList = (resp?.vendorList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.vendorID
                }
            }));
            setVendorList(vendorList);

        }, (error: any) => {
            setVendorList([]);

        });
    }

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };
    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const getSpearPartsList = () => {

        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };
        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }



        spearPartsAPI.getSpearPartsList(payload, (data: any) => {
            setTotalRecords(data.totalRecord);
            setRowData(data.sparePartsList ? data.sparePartsList : []);
        }, (error: any) => {
            setRowData([]);
        });
    };

    useEffect(() => {
        getPartsStatus();
        getPartsCategoryList();
        getvenderList();
    }, []);

    // Call getSpearPartsList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            getSpearPartsList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            getSpearPartsList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters]);

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };


    const onBulkExportPdf = () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const partsID = selectedData.map((parts: any) => parts.partsID).join(',');
        let payload: any = { sparePartsIDs: partsID };

        if (selectedData.length == 0) {
            payload = { pageSize: 0 };
        }
        spearPartsAPI.exportToPdf(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'SparePartsPdf')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const partsID = selectedData.map((parts: any) => parts.partsID).join(',');
        let payload:any = { sparePartsIDs: partsID };
        if (selectedData.length == 0) {
            payload = { pageSize: 0 };
        } 

        spearPartsAPI.exportToXls(
            payload,
            (resp: any) => { downloadExcel(resp, 'SparePartsXls') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
    const onBulkPrintQR = () => {
        if (!getPermissionInfo(location.pathname, "Print QR Code", loggedinuser)) {
            toast.error("You don't have Print QR Code permission");
            return;
        }

        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrList: any = [];
            selectedData.map((row: any) => qrList.push({ sparePartsID: row.partsID, qty: 1 }));
            const payload = { qrSparePartsList: qrList, sparePartsNameInQR: true };
            spearPartsAPI.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'SparePartsQR') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }


    };
    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                if (!getPermissionInfo(location.pathname, "Edit", loggedinuser)) {
                    toast.error("You don't have Edit permission");
                    return;
                }
                // Implement edit action
                setEditData(rowData);
                addNewRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "view":
                navigate(URLS.INVENTORY.SPEAR_PARTS.DETAILS(rowData.partsID));
                break;
            case "delete":
                if (!getPermissionInfo(location.pathname, "Delete", loggedinuser)) {
                    toast.error("You don't have Delete permission");
                    return;
                }
                confirm({
                    type: 'delete',
                    title: 'Delete Parts',
                    message: 'Are you sure you want to delete this Parts?',
                    onConfirm: () => {
                        const payload = { partsID: rowData.partsID };
                        spearPartsAPI.deleteSpearParts(payload, (resp: any) => {
                            toast.success('Parts deleted successfully');
                            getSpearPartsList();
                        }, (error: any) => {
                            console.log('error =>', error);
                            toast.error(error);
                        });
                    }
                });

                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };
    const handleClose = () => setIsOpen(false);
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, pinned: "left", minWidth: 50, width: 50, headerClass: 'bg-[#f0f0f0]', },
        {
            headerName: 'Image', field: 'image', pinned: "left", minWidth: 80, width: 80, headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => {
                return (
                    <div className='flex items-center justify-start h-full'>
                        <img src={data.data.imageFullPath ? data.data.imageFullPath : partsImg} className='w-[2rem] h-[2rem] rounded-full' onClick={() => { }} />
                    </div>
                )
            }
        },
        {
            headerName: 'Part Name', field: 'sparePartsName', pinned: "left", headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 250, cellRenderer: (data: any) =>
                <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>,
            onCellClicked: (param: any) => {
                navigate(URLS.INVENTORY.SPEAR_PARTS.DETAILS(param.data.partsID));
            }
        },
        { headerName: 'Part Code', field: 'partsCode', pinned: "left", width: 180, minWidth: 180, headerClass: 'bg-[#f0f0f0]', cellRenderer: titleCell },
        { headerName: 'Category', field: 'partsCategoryName', width: 150, headerClass: 'bg-[#f0f0f0]', cellRenderer: titleCell },
        { headerName: 'Qty. Incoming....', field: 'incomingQty', width: 140, headerClass: 'bg-[#f0f0f0]', cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value + ' ' + data?.data?.unitCode : '--'}</p> },
        {
            headerName: 'Qty. In Stock', field: 'currenctStock', width: 140, headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value + ' ' + data?.data?.unitCode : '--'}</p>
        },
        {
            headerName: 'Min. Qty', field: 'minStock', width: 90, headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value + ' ' + data?.data?.unitCode : '--'}</p>
        },
        {
            headerName: 'Max. Qty', field: 'maxStock', width: 100, headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value + ' ' + data?.data?.unitCode : '--'}</p>
        },
        // {
        //     headerName: 'Make', field: 'make', headerClass: 'bg-[#f0f0f0]',
        //     cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value : '--'}</p>
        // },
        // {
        //     headerName: 'Model', field: 'model', headerClass: 'bg-[#f0f0f0]',
        //     cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value : '--'}</p>
        // },
        {
            headerName: 'Vendor', field: 'vendorName', headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => <p title={data.value}>{data.value ? data.value : '--'}</p>
        },
        {
            headerName: 'Last Date of Purchase', field: 'addedDate', headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => data.value ? showDate(data.value) : '--'
        },

        { headerName: 'Status', field: 'partsStatusName', width: 100, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                const action = e.target.value;
                                if (action !== "view") {
                                    if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                        toast.error(`You don't have ${action} permission`);
                                        e.target.selectedIndex = -1;
                                        return;
                                    }
                                }

                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>
                            <option value="view">View</option>
                            <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>

                            {/*  <option value="duplicate">Duplicate</option>
                            <option value="move-asset">Move Asset</option>
                            <option value="qr">QR Code</option>
                            <option value="schedule-maintenance">Schedule Maintenance</option> */}
                        </select>
                    </div>
                );
            },
            width: 100
        }

    ];


    const createPartRef: any = useRef();
    return (
        <Layout>
            <Header title='Spare Parts'>
                <Header.Right>
                    <Drawer _ref={addNewRef} isAfterOpenRender={true} onClose={() => {
                        setEditData(null)
                        createPartRef?.current?.reset()
                    }
                    } outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>Add New Parts</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Parts' : 'Create New Parts'} className='!w-[39.563rem]'>
                            {!getPermissionInfo(location.pathname, "Add", loggedinuser) && !editData ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreateSpearparts _ref={createPartRef} editData={editData} onCreate={() => {
                                    setEditData(null);
                                    getSpearPartsList();
                                    addNewRef.current.close();
                                }} onCancel={() => {
                                    setEditData(null);
                                    addNewRef.current.close();
                                }} />
                            )}
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Print QR Code", loggedinuser)} onClick={onBulkPrintQR}>Print QR Code</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by part name or code'/>
            </div>





            <div>
                <div className='bg-[#FAFAFA]'>
                    <div className='flex gap-4 px-5 py-2 items-center'>
                        <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>

                        <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => { 
                            setFilters({});
                            localStorage.removeItem('spearPartsFilters');
                        }} >Clear Filters</p>
                    </div>
                    <div className="ag-theme-alpine mx-4  h-1/2">
                        <AgGridReact
                            columnDefs={columnDefs as any} // Pass columnDefs
                            rowData={rowData || []} // Pass rowData
                            pagination={false}
                            rowSelection="multiple"
                            onGridReady={onGridReady}
                            domLayout="autoHeight"
                            onRowClicked={onRowClicked}
                            loadingOverlayComponent={Loader}
                            noRowsOverlayComponent={() => (
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-center text-gray-500">
                                        <div className="text-lg font-medium">No Data Found</div>
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                </div>
                {/* Add your component code here */}
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default SpearParts;